import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StpRegistrationStorageService } from '../../../services/stp-registration-storage.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-approve-stp-correction-request',
  templateUrl: './approve-stp-correction-request.component.html',
  styleUrls: ['./approve-stp-correction-request.component.scss']
})
export class ApproveStpCorrectionRequestComponent implements OnInit {

  approveCorrectionRequestForm!: FormGroup;
  correctionRequestId: number;
  isSubmit: boolean = false;
  comparisonFields = [
    { label: 'STP Name', previousKey: 'prevStpName', requestedKey: 'stpName' },
    { label: 'STP Name in Bangla', previousKey: 'prevStpNameBangla', requestedKey: 'stpNameBangla' },
    { label: 'STP Location', previousKey: 'prevLocation', requestedKey: 'locationName' },
    { label: 'Country', previousKey: 'prevCountry', requestedKey: 'countryName' },
    { label: 'Division/State', previousKey: 'prevDivision', requestedKey: 'divisionName' },
    { label: 'District/City', previousKey: 'prevDistrict', requestedKey: 'districtName' },
    { label: 'Upazila/Sub-district', previousKey: 'prevUpazila', requestedKey: 'upazilaName' },
    { label: 'Post Office', previousKey: 'prevPostOffice', requestedKey: 'postOffice' },
    { label: 'Address', previousKey: 'prevAddress', requestedKey: 'address' },
  ];

  approvalStatusList: { id: number; name: string }[] = [
    { id: 1, name: 'Approved' },
    { id: 2, name: 'Rejected' },
  ];

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private notification: NzNotificationService,
    private router: Router
  ) {
    this.correctionRequestId = this.route.snapshot.params.id;
  }

  ngOnInit() {
    this.approveCorrectionRequestForm = this.fb.group({
      id: [''],
      stpMainId: [''],
      prevStpName: [''],
      prevStpNameBangla: [''],
      prevLocation: [''],
      prevCountry: [''],
      prevDivision: [''],
      prevDistrict: [''],
      prevUpazila: [''],
      prevPostOffice: [''],
      prevAddress: [''],
      stpName: [''],
      stpNameBangla: [''],
      locationId: [''],
      locationName: [''],
      countryId: [''],
      countryName: [''],
      divisionId: [''],
      divisionName: [''],
      districtId: [''],
      districtName: [''],
      upazilaId: [''],
      upazilaName: [''],
      postOffice: [''],
      address: [''],
      isPayment: [''],
      paymentAmount: [''],
      paymentDate: [''],
      transactionNo: [''],
      approvalStatusId: ['', [Validators.required]],
      rejectedRemarks: ['']
    });

    this.approveCorrectionRequestForm.get('approvalStatusId')?.valueChanges.subscribe((value) => {
      if (value == 2) {
        this.approveCorrectionRequestForm.get('rejectedRemarks')?.setValidators([Validators.required]);
        this.approveCorrectionRequestForm.get('rejectedRemarks')?.updateValueAndValidity();
      } else if (value == 1) {
        this.approveCorrectionRequestForm.get('rejectedRemarks')?.clearValidators();
        this.approveCorrectionRequestForm.get('rejectedRemarks')?.updateValueAndValidity();
        this.approveCorrectionRequestForm.get('rejectedRemarks')?.reset();
      } else if (value == null) {
        this.approveCorrectionRequestForm.get('rejectedRemarks')?.clearValidators();
        this.approveCorrectionRequestForm.get('rejectedRemarks')?.updateValueAndValidity();
        this.approveCorrectionRequestForm.get('rejectedRemarks')?.reset();
      }
    });

    this.getCorrectionRequestInfoById();
  }

  getCorrectionRequestInfoById() {
    this.stpRegistrationStorageService.getCorrectionRequestInfoById(this.correctionRequestId)
      .subscribe(
        (res) => {
          if (res.success) {
            this.approveCorrectionRequestForm.patchValue({
              id: res?.data?.id,
              stpMainId: res?.data?.stpMain?.id,
              prevStpName: res?.data?.prevStpName,
              prevStpNameBangla: res?.data?.prevStpNameBangla,
              prevLocation: res?.data?.prevStpLocation?.locationName,
              prevCountry: res?.data?.prevSysCountry?.countryName,
              prevDivision: res?.data?.prevSysDivision?.divisionName,
              prevDistrict: res?.data?.prevSysDistrict?.districtName,
              prevUpazila: res?.data?.prevSysUpazila?.upazillaName,
              prevPostOffice: res?.data?.prevPostOffice,
              prevAddress: res?.data?.prevAddress,
              stpName: res?.data?.stpName,
              stpNameBangla: res?.data?.stpNameBangla,
              locationId: res?.data?.stpLocation?.id,
              locationName: res?.data?.stpLocation?.locationName,
              countryId: res?.data?.sysCountry?.id,
              countryName: res?.data?.sysCountry?.countryName,
              divisionId: res?.data?.sysDivision?.id,
              divisionName: res?.data?.sysDivision?.divisionName,
              districtId: res?.data?.sysDistrict?.id,
              districtName: res?.data?.sysDistrict?.districtName,
              upazilaId: res?.data?.sysUpazila?.id,
              upazilaName: res?.data?.sysUpazila?.upazillaName,
              postOffice: res?.data?.postOffice,
              address: res?.data?.address,
              isPayment: res?.data?.isPayment,
              paymentAmount: res?.data?.paymentAmount,
              paymentDate: res?.data?.paymentDate,
              transactionNo: res?.data?.transactionNo,
              approvalStatusId: res?.data?.approvalStatusId,
              rejectedRemarks: res?.data?.rejectedRemarks
            });

            if(this.approveCorrectionRequestForm.get('approvalStatusId')?.value){
              this.isSubmit = true;
            }
          }else{
            this.notification.warning('Warning!', res?.message);
          }
        },
        (error) => {
          this.notification.error('Failed', 'Correction requested application not found !');
        }
      );
  }

  submitApprovalDecision(){
    this.stpRegistrationStorageService.submitCorrectionRequestApprovalDecision(this.getApprovalDecisionPayload()).subscribe({
      next: (res) => {
        if(res?.success){
          this.notification.success('Success!', res?.message);
          this.router.navigate(['home/stp-registration/correction-request-list']);
        }else{
          this.notification.warning('Warning!', res?.message);
        }
      },
      error: (error) => this.notification.error('Failed', error.message),
    });
  }

  getDisplayValue(controlName: string): string {
    const value = this.approveCorrectionRequestForm.get(controlName)?.value;

    if (value === null || value === undefined || value === '') {
      return '-';
    }

    return String(value);
  }

  isFieldChanged(previousKey: string, requestedKey: string): boolean {
    const previousValue = this.normalizeComparisonValue(this.approveCorrectionRequestForm.get(previousKey)?.value);
    const requestedValue = this.normalizeComparisonValue(this.approveCorrectionRequestForm.get(requestedKey)?.value);

    return previousValue !== requestedValue;
  }

  private getApprovalDecisionPayload(): any {
    const formValue = this.approveCorrectionRequestForm.getRawValue();

    return {
      id: formValue.id ?? null,
      stpMainId: Number(formValue.stpMainId ?? null),
      approvalStatusId: formValue.approvalStatusId ?? null,
      rejectedRemarks: formValue.rejectedRemarks ?? null,
    };
  }

  private normalizeComparisonValue(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    return String(value).trim().toLowerCase();
  }
}
